<template>
  <div>
    <yw-head></yw-head>
    <my-banner :Mytype="'index'"></my-banner>
    <div class="clearfix "></div>
    <div style="  position: relative;  width: 100%;">
      <div class="product-box-title-box">
        <div class="product-box-title">
          热门游戏
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="p_cloud cloud_left_1">
        <img class="cloud_left_1_img" src="../assets/cloud_left_1.png" alt="">
      </div>
      <div class="p_cloud cloud_left_2">
        <img class="cloud_left_2_img" src="../assets/cloud_left_2.png" alt="">
      </div>
      <div class="p_cloud cloud_right_1">
        <img class="cloud_right_1_img" src="../assets/cloud_right_1.png" alt="">
      </div>
      <div class="p_cloud cloud_right_2">
        <img class="cloud_right_2_img" src="../assets/cloud_right_2.png" alt="">
      </div>
      <div class="web-body">
        <div class="  clearfix product-box">
          <div class="    no-gutters product-container" ref="productContainer">
            <div v-for="(item,$index) in list " :key="$index" class="   product-item rounded-sm">
              <img class="product-item-bg-img"
                   :src="item.cover"
                   alt="">
              <div class="product-item-content-drawer-box">
                <div class="product-item-content-drawer-box-bg"></div>
                <div class="product-item-content-box">
                  <img class="product-item-logo-img  rounded-sm"
                       :src="item.icon"
                       alt="">
                  <div class="product-item-title-box">
                    <div class="product-item-title-line "></div>
                    <div class="product-item-title">{{item.name}}</div>
                    <div class="product-item-title-line "></div>
                  </div>
                  <div class="product-item-qrcode-summary">{{item.summary}}</div>
                </div>
              </div>
            </div>
            <div v-for="(item,$index) in emptyList " :key="'ep'+$index"
                 class="product-item rounded-sm product-item-empty">
            </div>
          </div>
        </div>
      </div>

      <yw-footer></yw-footer>
    </div>
  </div>
</template>

<script>
  import yw_head from './yw_head';
  import yw_footer from './yw_footer';
  import banner from './banner';
  import axios from 'axios';

  export default {
    name: "index",
    components: {
      'my-banner': banner,
      'yw-head': yw_head,
      'yw-footer': yw_footer
    },
    data() {
      return {
        rowNumber: 4,
        list: [],
        emptyList: [],
        listUrl: 'https://api.zuiqiangyingyu.cn/a81iWQArSR9sg7b9ih.php/api/website/product/Get_index_product_list',
      }
    },
    created() {
      this.getList();
    },
    mounted() {
      const that = this;
      window.addEventListener("resize", function () {
        return (() => {
          if (!that.timer) {
            that.timer = true
            setTimeout(function () {
              that.list.length > 0 && that.getEmptyItem();
              that.timer = false
            }, 500)
          }
        })();
      });
    },
    methods: {
      getList() {
        axios.get(this.listUrl).then((response) => {
          let $data = response.data;
          if ($data.c == 0) {
            if ($data.d.length > 0) {
              this.list = $data.d;
              this.$nextTick(() => {
                this.getEmptyItem();
              })
            }
          } else {
          }

        }).catch((error) => {
          console.log(error)
        })
      },
      getEmptyItem() {
        let childNodes = this.$refs.productContainer.childNodes, firstTop = -99999;
        this.rowNumber = 0;
        if (childNodes.length > 0) {
          firstTop = childNodes[0].getBoundingClientRect().top;
        }
        this.$refs.productContainer.childNodes.forEach((node) => {
          if (!!node.getBoundingClientRect && node.getBoundingClientRect().top === firstTop) {
            this.rowNumber++;
          }
        });
        let emptyListNumber = this.list.length % this.rowNumber ? this.rowNumber - this.list.length % this.rowNumber : 0;
        this.emptyList = new Array(emptyListNumber).fill({});
        console.log("    this.emptyList ", this.rowNumber, this.emptyList.length);
      }
    }
  }
</script>

<style scoped>

  .wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 80px 0px;
    position: relative;
  }

  .wrapper .mediaItem {
    padding: 0;
    margin: 3.5% 0% 0 0;
    float: left;
    width: 20%;
    text-align: center;
    display: block;
  }

  .wrapper .mediaItem img {
    max-width: 3rem;
    width: auto;
    /*max-height: 2rem;*/
    height: auto;
  }

  .product-box {
    /*padding: 0 .94rem;*/
    width: inherit;
    margin-top: 0;
  }

  .content-body {
    position: relative;
    width: 100vw;
    height: 100%;
    background: url(../assets/home-bg.jpg);
    background-size: cover;
    overflow: hidden;
    padding-bottom: 1.6rem;
    margin-top: -3px;
    padding-top: 10px;
  }

  .product-box-title-box {
    background-image: url(../assets/sawtooth.png);
    background-size: 2.09375rem 2.25rem;
    background-position: 0 -2px;
    font-size: 0.58rem;
    width: 100vw;
    color: #666;
    height: 2.25rem;
    z-index: 9999;
    margin-top: -1.125rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1rem;
  }

  .product-box-title {
    height: 0.8rem;
    width: 14.64rem;
    font-size: 0.5rem;
    line-height: 0.8rem;
    background-color: #0E99C4;
    background-image: linear-gradient(to right, rgba(235, 251, 254, 1), rgba(66, 176, 210, 1), #0E99C4, rgba(66, 176, 210, 1), rgba(235, 251, 254, 1));
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
  }

  .product-container {
    display: flex;
    flex-wrap: wrap;
    width: inherit;
    /*margin-left: -0.3rem;*/
    justify-content: space-between;
    margin-bottom: 1.33rem;
  }


  .product-item {
    height: 260px;
    margin: 0.45rem 0;
    width: 260px;
    overflow: hidden;
    position: relative;
    color: #333333;
    background-color: #fff;
    box-shadow: 0 0 0 8px #0E99C4;
    border-radius: 8px;
    transition: box-shadow 0.5s;
  }

  .product-item-empty {
    background-color: rgba(0, 0, 0, 0);
    box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0);
  }

  .product-item:hover {
    box-shadow: 0 0 0 8px #24D1F6;
  }

  .product-item:hover.product-item-empty {
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0);
  }

  .product-item-bg-img {
    height: 146px;
    width: 260px;
  }

  .product-item-content-drawer-box {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    margin-top: 113px;
    transition: margin-top 0.5s;
  }

  .product-item:hover .product-item-content-drawer-box {
    display: block;
    margin-top: 10px;
  }

  .product-item-content-drawer-box-bg {
    height: 100%;
    width: 100%;
    background: #fff;
    margin-top: 33px;
  }

  .product-item:hover .product-item-content-drawer-box-bg {
    margin-top: 50px;
  }

  .product-item-content-box {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .product-item-logo-img {
    height: 93px;
    width: 93px;
    margin-left: 85px;
    transition: height 0.5s, width 0.5s, margin-left 0.5s;
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px #FFE679;
  }

  .product-item:hover .product-item-logo-img {
    width: 57px;
    height: 57px;
    margin-top: 18px;
    margin-left: 101px;
  }

  .product-item-title {
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    color: #0E99C4;
    margin: 0 0.3rem;
    transition: color 0.5s, font-size 0.5s;
  }

  .product-item:hover .product-item-title {
    color: #24D1F6;
    font-size: 14px;
    margin: 0 0.2rem;
  }

  .product-item-title-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-item-title-line {
    width: 0.6rem;
    height: 0.04rem;
    background: #0E99C4;
    transition: background 0.5s;
  }

  .product-item:hover .product-item-title-line {
    background: #24D1F6;
  }

  .product-item:hover .drawer-box {
    top: 0;
  }

  .product-item-qrcode-summary {
    font-size: 12px;
    padding: 0 20px;
    text-align: center;
    display: none;
    white-space: pre-line;
  }

  .product-item:hover .product-item-qrcode-summary {
    display: block;
  }

  .p_cloud {
    position: absolute;
  }

  .p_cloud > img {
    width:100%;
  }

  .cloud_left_1 {
    width: 9.92rem;
    height: 6rem;
    left: -5.1rem;
    top: 1rem;
  }

  .cloud_left_2 {
    width: 4.76rem;
    height: 3.18rem;
    left: 10rem;
    bottom: -2.16rem;
  }

  .cloud_right_1 {
    width: 8.66rem;
    height: 5.7rem;
    right: -3.84rem;
    top: 5rem;
  }

  .cloud_right_2 {
    width: 4.86rem;
    height: 2.98rem;
    right: 10rem;
    bottom: -0.5rem;
  }


  @media screen and (max-width: 970px) {
    .product-item {
      height: 200px;
      width: 200px;
      margin: 20px 0;
      border-radius: 6px;
    }

    .product-item-bg-img {
      height: 112px;
      width: 200px;
    }

    .product-item-logo-img {
      height: 71px;
      width: 71px;
      margin-left: 64px;
    }

    .product-item-content-drawer-box {
      margin-top: 86px;
    }

    .product-item:hover .product-item-logo-img {
      width: 43px;
      height: 43px;
      margin-top: 13px;
      margin-left: 78px;
    }

    .product-item-title {
      font-size: 13px;
      line-height: 38px;
    }

    .product-item:hover .product-item-title {
      font-size: 10px;
    }

    .product-item-content-drawer-box-bg {
      margin-top: 25px;
    }

    .product-item:hover .product-item-content-drawer-box-bg {
      margin-top: 38px;
    }

    .product-item-qrcode-summary {
      font-size: 10px;
    }
  }

  @media screen and (max-width: 770px) {
    .product-item {
      margin: 13px 0;
    }
  }

  @media screen and (max-width: 770px) {
    .product-item {
      margin: 20px 0;
    }

    .content-body {
      padding-top: 15px;
    }
  }

  @media screen and (max-width: 540px) {
    .product-item {
      margin: 13px 0;
    }
  }

  @media screen and (max-width: 490px) {
    .product-item {
      height: 160px;
      width: 160px;
      margin: 10px 0;
      border-radius: 5px;
      box-shadow: 0 0 0 6px #0E99C4;
    }

    .product-item:hover {
      box-shadow: 0 0 0 6px #24D1F6;
    }

    .product-item-bg-img {
      height: 90px;
      width: 160px;
    }

    .product-item-logo-img {
      height: 56px;
      width: 56px;
      margin-left: 51px;
    }

    .product-item-content-drawer-box {
      margin-top: 68px;
    }

    .product-item:hover .product-item-logo-img {
      width: 34px;
      height: 34px;
      margin-top: 10px;
      margin-left: 62px;
    }

    .product-item-title {
      font-size: 10px;
      line-height: 30px;
    }

    .product-item:hover .product-item-title {
      font-size: 8px;
    }

    .product-item-content-drawer-box-bg {
      margin-top: 20px;
    }

    .product-item:hover .product-item-content-drawer-box-bg {
      margin-top: 30px;
    }

    .product-item-qrcode-summary {
      font-size: 8px;
    }

    .product-box-title-box {
      background-size: 35px;
      height: 35px;
    }

    .product-box-title {
      z-index: 999;
    }

    .cloud_left_2 {
      left: 20px;
    }
    .cloud_right_2 {
      right: 40px;
    }


  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue